<template>
  <div>
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-9 gap-y-8 mt-10"
    >
      <template v-if="isLoading">
        <div v-for="i in 4" :key="i">
          <UtilsSkeletonLoading class="rounded-lg h-40 w-full mb-4 card-img" />
          <UtilsSkeletonLoading class="w-full h-14 mb-3" />
          <UtilsSkeletonLoading class="w-full h-12" />
        </div>
      </template>
      <template v-else>
        <ArticleCard
          v-for="content in contentsData"
          :key="content.id"
          :with-logo="false"
          :title="content.attributes?.card_title"
          :desc="content.attributes?.layout_component?.[0]?.description"
          :image-url="content.attributes?.image?.data?.attributes?.url"
          :slug="`/sustainability/${content.attributes?.slug}`"
        />
      </template>
      <template v-if="isLoadingMore">
        <div v-for="i in 4" :key="i">
          <UtilsSkeletonLoading class="rounded-lg h-40 w-full mb-4 card-img" />
          <UtilsSkeletonLoading class="w-full h-14 mb-3" />
          <UtilsSkeletonLoading class="w-full h-12" />
        </div>
      </template>
    </div>
    <!-- <div
      v-if="
        contentsMeta?.pagination?.page < contentsMeta?.pagination?.pageCount
      "
      class="mx-auto text-center mt-10"
    >
      <button
        class="px-3 py-[10px] sm:py-3 sm:px-5 text-sm sm:text-base border border-[#FF6700] rounded-md text-[#FF6700] block w-max mx-auto hover:bg-[#FF6700] hover:text-white"
        @click="loadMore"
      >
        Load More
      </button>
    </div> -->
  </div>
</template>

<script setup>
// VARIABLE DECLARATION
const isLoading = ref(true)
const isLoadingMore = ref(false)

const page = ref(1)
const contentsData = ref([])
const contentsMeta = ref({})

const props = defineProps({
  typeId: {
    type: Number,
    required: true
  }
})

// METHODS
const getContents = async () => {
  const { data, error, pending } = await useSuitmediaApiData(`/api/contents`, {
    query: {
      'pagination[page]': page,
      'pagination[pageSize]': 4,
      populate: 'image,layout_component,layout_component.type',
      'filters[$and][0][layout][$eq]': 'sustainability',
      sort: 'publish_at:desc',
      'filters[$and][1][sustainability_type][id][$eq]': props.typeId
    }
  })
  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Ideas does not exist`
    })
  }

  return data.value
}

// eslint-disable-next-line no-unused-vars
const loadMore = async () => {
  isLoadingMore.value = true
  page.value++
  const addContents = await getContents()
  contentsData.value = [...contentsData.value, ...addContents.data]
  contentsMeta.value = addContents.meta
  isLoadingMore.value = false
}

// FIRST LOAD DATA
const contents = await getContents()
contentsData.value = contents.data
contentsMeta.value = contents.meta
</script>

<style lang="scss" scoped></style>
